import React, { useState, useMemo } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { debounce } from '@mui/material/utils';

const StyledSearchBar = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 6,

        '& input': {
            padding: '10px 12px',
            fontSize: '0.875rem',
        },
    },
}));

const LsSearchBar = ({
    placeholder = 'Search...',
    onSearch,
    debounceMs = 300,
    fullWidth = true,
    ...props
}) => {
    const [value, setValue] = useState('');

    const debouncedSearch = useMemo(
        () => debounce((searchValue) => {
            onSearch?.(searchValue);
        }, debounceMs),
        [onSearch, debounceMs]
    );

    const handleChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
        debouncedSearch(newValue);
    };

    const handleClear = () => {
        setValue('');
        onSearch?.('');
    };

    return (
        <StyledSearchBar
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            fullWidth={fullWidth}
            size="small"
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon fontSize="small" color="action" />
                    </InputAdornment>
                ),
                endAdornment: value && (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={handleClear}>
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    );
};

export default LsSearchBar;